import dayjs from "dayjs";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getUserProfileAction } from "../../Redux/Actions/UserProfileAction";
import { Constants } from "../Common/Constants";
import { DumbbellIcon } from "./DumbbellIcon";

const CardBlock = ({ user }) => {
  // Card for Created At, Name, Email, Number
  const { id } = useParams();
  const dispatch = useDispatch();
  const userProfile = useSelector((store) => store.UserProfileReducer.userProfile);

  useEffect(function () {
    dispatch(getUserProfileAction(id));
  }, [id]);

  const OrderDetailData = [
    {
      mainbgColor: "grey_bg",
      bgColor: "grey_dark_bg",
      icon: "icofont-ui-calendar fa-lg",

      name: Constants.joiningDate,
      secondName: `${dayjs(userProfile?.createdAt).format(
        Constants.dateFormat
      )} at ${dayjs(userProfile?.createdAt).format(Constants.timeFormat)}`,
    },
    {
      mainbgColor: "grey_bg",
      bgColor: "grey_dark_bg",
      icon: "fa fa-user fa-lg",
      name: Constants.age,
      // secondName: `${user?.age} years` || Constants.na,
      // secondName: `${dayjs().diff(userProfile.dob, 'year')} years` || Constants.na,
      secondName: userProfile?.dob && dayjs(userProfile.dob).isValid() ? `${dayjs().diff(dayjs(userProfile.dob), "year")} years` : Constants.notProvided

    },
    {
      mainbgColor: "grey_bg",
      bgColor: "grey_dark_bg",
      icon: "fa fa-envelope fa-lg",
      name: Constants.email,
      secondName: userProfile?.email || Constants.notProvided,
    },
    {
      mainbgColor: "grey_bg",
      bgColor: "grey_dark_bg",
      icon: "fa fa-phone-square fa-lg",
      name: Constants.number,
      secondName: `${userProfile?.mobile ? userProfile?.mobile : "Not provided"}` || Constants.na,
    },
    {
      mainbgColor: "grey_bg",
      bgColor: "grey_dark_bg",
      icon: "fa fa-dumbbell fa-lg",
      svgIcon: <DumbbellIcon />,
      name: Constants.currentWeight,
      secondName: `${userProfile?.weight ? userProfile.weight : "Not provided"}` || Constants.na,
    },
  ];

  return (
    <>
      <div className="">
        <div className="row g-3 mb-3 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
          {OrderDetailData.map((order, i) => {
            return (
              <div key={"s" + i} className="col">
                <div className={`${order.mainbgColor} alert mb-0 `}>
                  <div className="d-flex align-items-center">
                    <div
                      className={`avatar rounded no-thumbnail ${order.bgColor} text-light`}
                    >
                      {/* <i className={order.icon}></i> */}
                      {order.name === "Current Weight" ? <DumbbellIcon /> : <i className={order.icon}></i>}

                    </div>
                    <div className="flex-fill ms-3 text-truncate">
                      <div className="h5 d-flex justify-content-between align-items-center mb-0" style={{ fontSize: "1rem", fontWeight: "bold" }}>
                        {order.name}
                      </div>
                      <span>{order.secondName}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default CardBlock;
